module.exports = __webpack_public_path__ + "img/pleisure_bodyimage03.0f616311.jpg";